// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_7u_","cls2":"LoggedInDiscoveryPage-cls2_Poz LoggedInDiscoveryPage-cls1_7u_"};